__turbopack_context__.v({
  "mainColumn": "MainColumn-module__aSptPa__mainColumn",
});
